<template>
  <div class="spec-component">
    <div class="spec">
      <prismic-rich-text class="bolder" :field="title" />
      <div v-if="tooltipText" v-b-tooltip.hover.bottom :title="tooltipText">
        <Icon :width="23" :height="23" color="var(--primary-color)" icon="more-info" />
      </div>
    </div>
    <ul class="list-group list-group-flush">
      <li
        v-for="(subSpec, subSpecIndex) in subSpecs"
        :key="subSpecIndex"
        class="sub-spec list-group-item"
      >
        <p>{{ subSpec }}</p>
        <i
          class="ph-bold ph-check"
          :style="{ fontSize: '20px', color: 'var(--terciary-color)' }"
        ></i>
      </li>
    </ul>
  </div>
</template>

<script>
import Icon from '@/components/UI/Icon.vue';

export default {
  components: { Icon },
  props: {
    title: {
      type: Array,
      required: true
    },
    tooltipText: {
      type: String,
      required: true
    },
    subSpecs: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.spec-component {
  display: grid;
  gap: 1em;
  p {
    margin: 0;
  }
  .bolder {
    font-weight: 600;
  }
  .list-group-item {
    background-color: inherit;
    border: inherit;
    padding: 0;
  }
  .spec {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .sub-spec {
    display: flex;
    justify-content: space-between;
  }
}
</style>
